import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";

export interface PayoutSchedulePayload {
  businessId?: number | string;
  frequency?: string;
  isActive?: boolean;
}

export interface GetPayoutSchedulesParams {
  page?: number;
  pageSize?: number;
  search?: string;
  isActive?: boolean | string;
  businessId?: number | string;
  frequency?: string;
  orderBy?: string;
  orderDirection?: TableSortValue;
}

export interface PayoutScheduleRecord {
  id?: number | string;
  businessId?: number | string;
  businessName?: string | null;
  frequency?: string;
  isActive?: boolean;
  lastPayoutAt?: string | null;
  updatedAt?: string;
  createdAt?: string;
}

export class PayoutScheduleService {
  async getPayoutSchedules(query?: GetPayoutSchedulesParams) {
    return apiService.get("/payout-schedules", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getPayoutSchedule(id: string | number) {
    return apiService.get(`/payout-schedules/${id}`);
  }

  async createPayoutSchedule(
    data: PayoutSchedulePayload & { businessId: number | string }
  ) {
    return apiService.post("/payout-schedules", data);
  }

  async updatePayoutSchedule(id: string | number, data: PayoutSchedulePayload) {
    return apiService.put(`/payout-schedules/${id}`, data);
  }

  async deletePayoutSchedule(id: string | number) {
    return apiService.delete(`/payout-schedules/${id}`);
  }
}

export const payoutScheduleService = new PayoutScheduleService();
